import { createStore } from 'redux';
import rootReducer from './reducers/index';
import { read_is_token_current } from '../services/authentication/session_tokens';

function hasToken(token) {
    return read_is_token_current(token);
}

function sanitizePersistedAuthState(state) {
    if (!state || !state.user) {
        return state;
    }

    if (hasToken(state.user.token)) {
        return state;
    }

    return {
        ...state,
        user: {
            ...state.user,
            user: false,
            token: ''
        }
    };
}

function saveToLocalStorage(state) {
    try {
        const serialisedState = JSON.stringify(state);
        localStorage.setItem('persistantState', serialisedState);
    } catch (error) {
    }
}

function loadFromLocalStorage() {
    try {
        const serialisedState = localStorage.getItem('persistantState');

        if (serialisedState === null) {
            return undefined;
        }

        return sanitizePersistedAuthState(JSON.parse(serialisedState));
    } catch (error) {
        return undefined;
    }
}

const store = createStore(rootReducer, loadFromLocalStorage());

store.subscribe(() => saveToLocalStorage(store.getState()));

export default store;
